import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import EnviosLayout from "./EnviosLayout";
import { ENVIOS_BASE, enviosDefaultRoute } from "./config";
import EnviosListSection from "./sections/EnviosListSection";
import TrackingLinksView from "./sections/tracking-links/TrackingLinksView";
import SmartTrackingView from "./sections/smart-tracking/SmartTrackingView";
import RutasView from "./sections/rutas/RutasView";
import ViajesView from "./sections/viajes/ViajesView";
import EnviosDetailPage from "./EnviosDetailPage";

export const enviosRoute: RouteObject = {
  path: ENVIOS_BASE,
  element: <EnviosLayout />,
  children: [
    { index: true, element: <Navigate to={enviosDefaultRoute} replace /> },
    { path: "todos", element: <EnviosListSection /> },
    { path: "envios-inteligentes", element: <SmartTrackingView /> },
    { path: "links-seguimiento", element: <TrackingLinksView /> },
    { path: "rutas", element: <RutasView /> },
    { path: "viajes", element: <ViajesView /> },
    { path: "detalle/:guia", element: <EnviosDetailPage /> },
  ],
};
